import styled from "@emotion/styled";
import React, { useEffect, useRef, useState } from "react";
import { has } from "lodash";

import { useForm } from "react-hook-form";

import buttonStyles from "~/styles/buttonStyles";
import FriendlyCaptcha from "~/components/FriendlyCaptcha";
import CaptchaTermsAndConditions from "~/components/FormExtras/CaptchaTermsAndConditions";

import Row from "~/components/layout/Row";
import Col from "~/components/layout/Col";

import FormFields from "~/queryBlocks/Form/components/FormFields";

import useFormSubmission from "~/queryBlocks/Form/hooks/useFormSubmission";

import { notifyUserOfException } from "~/utilities/formHelpers";

const Submit = styled.input`
    ${({ theme }) => buttonStyles({ theme, color: "purple" })};
    border: 0;
    appearance: none;
    opacity: ${({ disabled }) => (disabled ? "0.45" : "1")};
`;

const HtmlForm = (props) => {
    const {
        presetValues,
        formPresetErrors,
        formInformation,
        uniqueFormId,
        formId,
        modalForm,
        handleModalScroll,
    } = props;

    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
        control,
        clearErrors,
        reset,
        getValues,
        setFocus,
        setError,
    } = useForm({
        reValidateMode: "onSubmit",
        defaultValues: presetValues,
        shouldFocusError: false,
    });

    const captchaRef = useRef(null);
    const [token, setToken] = useState(null);

    useEffect(() => {
        if (formPresetErrors) {
            reset(presetValues, { keepErrors: true });
            notifyUserOfException(formPresetErrors, uniqueFormId, setError);
        } else {
            reset(presetValues);
        }
    }, [presetValues, reset, formPresetErrors, uniqueFormId, setError]);

    const formProps = {
        ...props,
        reset,
        setError,
    };

    const { handleFormSubmission } = useFormSubmission(formProps);

    const onCaptchaComplete = (token) => {
        setToken(token);
    };

    const onSubmit = (data) => {
        handleFormSubmission(data, token);
    };

    return (
        <>
            <form
                noValidate={true}
                data-form-id={formId}
                onSubmit={handleSubmit(onSubmit)}
            >
                <Row>
                    <FormFields
                        {...{
                            formFields: formInformation?.formFields,
                            setFocus,
                            register,
                            errors,
                            uniqueFormId,
                            control,
                            getValues,
                            modalForm,
                            handleModalScroll,
                        }}
                    />
                    <Col xs={1}>
                        <Submit
                            type="submit"
                            onClick={() => {
                                if (
                                    has(errors, "unknown") ||
                                    has(errors, "on24_error")
                                ) {
                                    clearErrors(["unknown", "on24_error"]);
                                }
                            }}
                            disabled={
                                !token ||
                                isSubmitting ||
                                has(errors, "non_field_error")
                            }
                            value={formInformation.button.text}
                        />
                    </Col>
                </Row>
            </form>
            <FriendlyCaptcha
                ref={captchaRef}
                onComplete={onCaptchaComplete}
                startMode="auto"
            />
            <CaptchaTermsAndConditions />
        </>
    );
};

export default HtmlForm;
